import React from 'react';
import { Pressable, StyleSheet, Text, type PressableStateCallbackType } from 'react-native';
import { Feather } from '@expo/vector-icons';
import { Paprika } from '../../styles/theme';

interface Props {
  label: string;
  onPress: () => void;
  disabled?: boolean;
  testID: string;
}

/** One axis of the profile; tapping flips it and rebuilds the week. */
export function AxisChip({ label, onPress, disabled, testID }: Props) {
  return (
    <Pressable
      onPress={onPress}
      disabled={disabled}
      testID={testID}
      accessibilityRole="button"
      accessibilityLabel={label}
      style={({ hovered }: PressableStateCallbackType & { hovered?: boolean }) => [styles.chip, hovered && !disabled && styles.chipHover, disabled && styles.chipDisabled]}
    >
      <Text style={styles.label}>{label}</Text>
      <Feather name="repeat" size={12} color={Paprika.accent} />
    </Pressable>
  );
}

const styles = StyleSheet.create({
  chip: {
    flexDirection: 'row', alignItems: 'center', gap: 6,
    paddingVertical: 7, paddingHorizontal: 11, borderRadius: 999,
    backgroundColor: Paprika.cardBg, borderWidth: 1, borderColor: Paprika.brandSoft,
  },
  chipHover: { borderColor: Paprika.accent },
  chipDisabled: { opacity: 0.5 },
  label: { fontFamily: 'Inter-Medium', fontSize: 12, color: Paprika.textPrimary },
});
